import { render, staticRenderFns } from "./DNSDepartments.vue?vue&type=template&id=b3764386&"
import script from "./DNSDepartments.vue?vue&type=script&lang=ts&"
export * from "./DNSDepartments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports